import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractAuditDto, AuditGroupDto, AuditModificationDto, AuditModificationFieldDto, AuditSearchDto, AuditViewDto } from '../../../service/dto';
import { PdfService } from '../../../service/pdf-service';

@Component({
	selector: 'app-audit-timeline',
	standalone: false,
	templateUrl: './audit-timeline.component.html',
	styleUrl: './audit-timeline.component.scss'
})
export class AuditTimelineComponent {
	@ViewChild('contentToPrint', { static: false }) contentToPrintElement!: ElementRef;
	_audits!: AbstractAuditDto[];
	@Input() downloadHeading!: string;
	@Input() downloadName!: string;


	getAsGroup(input: AbstractAuditDto): AuditGroupDto {
		return input as AuditGroupDto;
	}
	@Input()
	set audits(input: AbstractAuditDto[]) {
		this._audits = input
			? [...input].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
			: [];
	}

	exportCsv() {
		const header = 'Date,Label,Username,Type,RecordId, SecondaryId';

		const data = this._audits!
		.flatMap(item => {
			if(item.type!='Group'){
				return [item];
			}
			return (item as AuditGroupDto).items;
		})
		.flatMap(item => {
			//just incase there is a nested group
			if(item.type!='Group'){
				return [item];
			}
			return (item as AuditGroupDto).items;
		})
		.map(row => {
			if (row.type == 'View') {
				const audit = row as AuditViewDto;
				return `${this.escapeCsv(audit.date)},${this.escapeCsv(audit.recordLabel)},${this.escapeCsv(audit.viewedBy.username)},${this.escapeCsv(audit.recordType)},${this.escapeCsv(audit.recordId)},${this.escapeCsv(audit.recordIdSecondary)},`;
			}
			if (row.type == 'Search') {
				const audit = row as AuditSearchDto;
				return `${this.escapeCsv(audit.date)},${this.escapeCsv(audit.recordLabel)},${this.escapeCsv(audit.searchedBy.username)},${this.escapeCsv(audit.recordType)},${this.escapeCsv(audit.recordCount)},${audit.filters.map(i => this.escapeCsv(i.filterName) + "," + this.escapeCsv(i.filterValue)).join(",")},`;
			}
			if (row.type == 'Modification') {
				const audit = row as AuditModificationDto;
				for(let field of audit.fields){
					return `${this.escapeCsv(audit.date)},${this.escapeCsv(audit.recordLabel)},${this.escapeCsv(field.fieldName)},${this.escapeCsv(field.before)},${this.escapeCsv(field.after)},${this.escapeCsv(field.same)},`;
				}
			}
			return ``;
		}).join("\n");

		const blob = new Blob([header + '\n' + data], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = this.downloadName + '.csv';
		a.click();
		URL.revokeObjectURL(url);
	}
	private escapeCsv(value: any): string {
		if (value == null) return '';
		return `"${String(value).replace(/"/g, '""')}"`;
	}
}
